// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_jl","advertCardPhoto__image":"c-a_jm"};